import axios from "axios";
import store from "../store/index";
import { getExceptionMessage, API_BASE_URL    , listProps } from "../utils/helper";
import { processResponse } from "./serviceUtil";
import { FI } from "../constants/sharedConstants";

export const traceQueueService = {
    searchTraceQueue,
    closeTraceQueue,
    sendTraceQueue,
    readTraceMessages
};

function searchTraceQueue(traceQueueData, props) {
    return (dispatch) => {
        const user = store.getState()?.loginUserReducer.user;
        const fiDetail = store.getState()?.fiReducer;
        const token = store.getState()?.loginUserReducer.token;

        const request = {   userId: user.userId,
                    languageCode: user.languageCode,
                    roleType: user?.role?.role_type,
                    fiCompanyNumber: user?.fiCompanyNumber,
                    ...traceQueueData
                };
        if (user.fiNumber == FI.CTB_BILLER && user.billerCrossReferenceDto)
            request.ctbId = user.billerCrossReferenceDto.centralizedBillerId;
        axios
            .post(
                `${API_BASE_URL()}/searchTraceQueue`,
                request,
                { headers: { "Content-Type": "application/json", Authorization: "Bearer " + token, } }
            )
            .then((res) => {
                const response = {
                    data: res.data,
                    traceQueueDetails: { ...traceQueueData },
                };
                dispatch( {data: response,  type: "GET_TRACE_QUEUE_SUCCESS"} );
                processResponse(true, props);
            })
            .catch((error) => {
                let errorMessage = getExceptionMessage(error);
                dispatch( {error: errorMessage,  type: "GET_TRACE_QUEUE_ERROR"} );
                processResponse(false, props, errorMessage);
            });
    };
}

function closeTraceQueue(traceQueueData, props) {
    return (dispatch) => {
        const user = store.getState()?.loginUserReducer.user;
        const fiDetail = store.getState()?.fiReducer;
        const token = store.getState()?.loginUserReducer.token;

        axios
        .post(
            `${API_BASE_URL()}/close-traceQueue`,
            {   userId: user.userId,
                languageCode: user.languageCode,
                role_type: user?.role?.role_type,
                ...traceQueueData
            },
            { headers: { "Content-Type": "application/json", Authorization: "Bearer " + token, } }
        )
        .then((res) => {
            const response = {
                data: res.data,
                traceQueueDetails: { ...traceQueueData },
            };
            dispatch( {data: response,  type: "CLOSE_TRACE_FOR_TRACE_QUEUE_SUCCESS"} );
            processResponse(true, props);
        })
        .catch((error) => {
            let errorMessage = getExceptionMessage(error);
            dispatch( {error: errorMessage,  type: "CLOSE_TRACE_FOR_TRACE_QUEUE_FAILURE"} );
            processResponse(false, props, errorMessage);
        });
    };
}

function sendTraceQueue(traceQueueData, props) {
    return (dispatch) => {
        const user = store.getState()?.loginUserReducer.user;
        const selectedFiNumber = user.fi?.fi_number;
        const token = store.getState()?.loginUserReducer.token;

        axios
        .post(
            `${API_BASE_URL()}/send-traceQueue`,
            {   userId: user.userId,
                languageCode: user.languageCode,
                role_type: user?.role?.role_type,
                selectedFiNumber,
                ...traceQueueData
             },
            { headers: { "Content-Type": "application/json", Authorization: "Bearer " + token, } }
        )
        .then((res) => {
            const response = {
                data: res.data, ///  the updated tp
                traceQueueDetails: { ...traceQueueData },
            };
            dispatch( {data: response,  type: "SEND_TRACE_FOR_TRACE_QUEUE_SUCCESS"} );
            processResponse(true, props);
        })
        .catch((error) => {
            let errorMessage = getExceptionMessage(error);
            dispatch( {error: errorMessage,  type: "SEND_TRACE_FOR_TRACE_QUEUE_FAILURE"} );
            processResponse(false, props, errorMessage);
        });
  };
}

function readTraceMessages(traceQueueReq, props) {
    return (dispatch) => {
        const user = store.getState()?.loginUserReducer.user;
        const token = store.getState()?.loginUserReducer.token;

        axios
        .post(
            `${API_BASE_URL()}/readTraceMessages`,
            {   userId: user.userId,
                languageCode: user.languageCode,
                roleType: user?.role?.role_type,
                ...traceQueueReq
            },
            { headers: { "Content-Type": "application/json", Authorization: "Bearer " + token, } }
        )
        .then((res) => {
            const response = {
                data: res.data,
            };
            dispatch( {data: response,  type: "READ_TRACE_MESSAGES_SUCCESS"} );
            processResponse(true, props);
        })
        .catch((error) => {
            let errorMessage = getExceptionMessage(error);
            dispatch( {error: errorMessage,  type: "READ_TRACE_MESSAGES_FAILURE"} );
            processResponse(false, props, errorMessage);
        });
    };
}
